
import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Col, Row } from '@flightstats/airframe-react';

import { PageContext } from '../components/page';
import MessageConfigTripGroupDropdown from '../components/messageConfigTripGroupDropdown';
import { BodyCard } from '../components/styledComponent';
import type { SearchBodyProps } from '../../types/messageConfiguration';
import { FilterLabeledInputRowWrapper } from '../../components/forms/Input';
import ButtonDefault from '../../components/forms/Buttons';
import { deleteMessageConfig } from '../../service/messageConfigurationService';
import { MessageConfigurationWithUrlPath } from '../../appRoutes';

const SearchBody: React.FC<SearchBodyProps> = ({
  onSelect,
  messageConfigs,
  cloneConfig,
}) => {
  const { messageConfigurationId } = useParams<{ messageConfigurationId: string }>();
  const { pushAlert } = useContext(PageContext);
  const navigate = useNavigate();
  const id = 'tripGroupDropdown';
  const selectedName =
    messageConfigs.find(config => {
      return messageConfigurationId === config.id;
    })?.name ?? '';

  useEffect(() => {
    if (
      messageConfigs.length && // don't fire if messageConfigs is an empty array
      messageConfigurationId && // and if messageConfigurationId is not passed
      !messageConfigs.some(messageConfig => {
        // and the messageConfigurationId is in the options list
        return messageConfig.id === messageConfigurationId;
      })
    ) {
      pushAlert(
        'danger',
        `No Email Configuration Found For Id: ${messageConfigurationId}, Loading Default.`,
        0,
      );
    }
  }, [messageConfigs]);

  const deleteConfig = async () => {
    const message =
      'This configuration customization will be removed from all trip groups it is applied to and they will start inheriting their parent configuration.';
    if (window.confirm(message)) {
      try {
        if (messageConfigurationId) {
          await deleteMessageConfig(messageConfigurationId);
        } else {
          pushAlert('danger', 'Invalid message configuration ID.');
        }
        navigate(
          MessageConfigurationWithUrlPath.replace(':messageConfigurationId', ''),
        );
      } catch (err: any) {
        pushAlert('danger', err.message);
      }
    }
  };

  return (
    <BodyCard>
      <Row>
        <Col>
          <FilterLabeledInputRowWrapper
            elementId={id}
            label="Selected Configuration"
          >
            <MessageConfigTripGroupDropdown
              id={id}
              onSelect={onSelect}
              value={messageConfigurationId}
              messageConfigs={messageConfigs}
            />
          </FilterLabeledInputRowWrapper>
        </Col>
        <Col align="flex-end" style={{ marginRight: '25px' }}>
          <ButtonDefault
            id="cloneButton"
            onClick={() =>
              messageConfigurationId ? cloneConfig(messageConfigurationId, `${selectedName}-COPY`) : pushAlert('danger', 'Invalid message configuration ID.')
            }
            type="button"
          >
            Clone Email Configuration
          </ButtonDefault>
          <br />
          <ButtonDefault id="deleteButton" onClick={deleteConfig} type="button">
            Delete Email Configuration
          </ButtonDefault>
        </Col>
      </Row>
    </BodyCard>
  );
};

export default SearchBody;
